import React from 'react';

const NotificationModalPlaceHolder = () => {
    
    const handleOpenSettings = () => {
        // Logic to open settings goes here
        window.location.href = '/#/app/settings/globalnotifs/all/';
    };
    return (
        <div className="flex flex-col items-center justify-center h-full w-full">
            <div className='flex justify-center items-center w-full'>
                <svg width="181" height="190" viewBox="0 0 181 190" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.969261" width="163" height="158" rx="40" fill="url(#paint0_radial_3562_33179)" />
                    <g clipPath="url(#clip0_3562_33179)">
                        <path
                            d="M39.0723 102.024C39.6804 102.632 40.4378 103.069 41.2684 103.292C42.099 103.514 42.9736 103.514 43.8042 103.292C44.6348 103.069 45.3922 102.632 46.0003 102.024C46.6083 101.416 47.0456 100.659 47.2682 99.828"
                            stroke="#E7E7E7"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M58.5888 63.8279C57.1306 58.3861 53.9699 54.1612 50.0529 50.8997"
                            stroke="#E7E7E7"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M18.8986 93.041C18.6803 93.4625 18.5892 93.9385 18.6364 94.4109C18.6836 94.8833 18.8671 95.3318 19.1645 95.7019C19.4619 96.0719 19.8605 96.3476 20.3117 96.4953C20.7629 96.643 21.2473 96.6564 21.706 96.5338L59.5624 86.3902C60.021 86.2675 60.434 86.0142 60.7513 85.6611C61.0686 85.308 61.2764 84.8703 61.3495 84.4013C61.4226 83.9322 61.3579 83.452 61.1631 83.0191C60.9684 82.5862 60.6521 82.2192 60.2526 81.9627C56.2366 79.5621 51.9768 77.0087 49.1246 66.3639C48.1157 62.5989 45.6525 59.3888 42.2769 57.4399C38.9012 55.4909 34.8896 54.9628 31.1246 55.9716C27.3595 56.9805 24.1494 59.4437 22.2005 62.8193C20.2516 66.195 19.7234 70.2066 20.7323 73.9716C23.5845 84.6164 21.1697 88.9582 18.8986 93.041Z"
                            fill="white"
                            stroke="#E7E7E7"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12.1962 61.0434C10.4347 65.8264 9.80987 71.0656 11.268 76.5075"
                            stroke="#E7E7E7"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <g clipPath="url(#clip1_3562_33179)">
                        <path
                            d="M169.364 74.014L131.709 69.0022C129.11 68.6562 126.722 70.483 126.376 73.0825L122.617 101.324C122.271 103.923 124.098 106.311 126.697 106.657L164.352 111.669C166.952 112.015 169.339 110.188 169.685 107.588L173.444 79.3473C173.79 76.7478 171.963 74.36 169.364 74.014Z"
                            fill="white"
                            stroke="#E7E7E7"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M173.131 81.7007L150.235 92.3055C149.448 92.664 148.576 92.7936 147.718 92.6795C146.861 92.5654 146.053 92.2121 145.387 91.6602L126.062 75.4359"
                            stroke="#E7E7E7"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <path
                        d="M104.735 102.63L67.3814 105.276C63.2554 105.569 60.1477 109.15 60.44 113.276L64.6748 173.042C64.9671 177.168 68.5489 180.275 72.6748 179.983L110.028 177.336C114.154 177.044 117.262 173.462 116.969 169.336L112.735 109.571C112.442 105.445 108.861 102.337 104.735 102.63Z"
                        fill="white"
                        stroke="#E7E7E7"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M90.2927 163.718L90.3301 163.716"
                        stroke="#E7E7E7"
                        strokeWidth="7.48939"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <defs>
                        <radialGradient
                            id="paint0_radial_3562_33179"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(83.6012 179.293) rotate(-111.443) scale(140.574 161.653)">
                            <stop stopColor="#E0E9ED" />
                            <stop offset="1" stopColor="#E0E9ED" stopOpacity="0" />
                        </radialGradient>
                        <clipPath id="clip0_3562_33179">
                            <rect
                                width="58.7878"
                                height="58.7878"
                                fill="white"
                                transform="translate(1.46438 58.847) rotate(-15)"
                            />
                        </clipPath>
                        <clipPath id="clip1_3562_33179">
                            <rect
                                width="56.9803"
                                height="56.9803"
                                fill="white"
                                transform="translate(123.549 58.3353) rotate(7.5815)"
                            />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div className="flex-1 flex flex-col items-center justify-center mt-6">
                <h5 className="text-[#3E3E3E] text-center font-outfit text-[24px] font-bold leading-[28px] tracking-[-0.48px]">
                    Notifications are currently off
                </h5>
                <p className="text-[#646464] text-center text-[18px] font-normal leading-[18px] tracking-[0.18px] font-[Outfit] mt-2">
                    Enable and customize your notification options in Settings.
                </p>
                <button className="text-[#0094CC] text-[16px] font-semibold leading-[16px] font-[Outfit] mt-4" onClick={handleOpenSettings}>
                    Open Settings
                </button>
            </div>
        </div>
    );
};

export default NotificationModalPlaceHolder;
